import { render, staticRenderFns } from "./NativeShortcutsDrawer.vue?vue&type=template&id=349ffa17&scoped=true"
import script from "./NativeShortcutsDrawer.vue?vue&type=script&lang=js"
export * from "./NativeShortcutsDrawer.vue?vue&type=script&lang=js"
import style0 from "./NativeShortcutsDrawer.vue?vue&type=style&index=0&id=349ffa17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349ffa17",
  null
  
)

export default component.exports